import * as DL from './../DL/Rollers';

/**
 * BUSINESS LOGIC (BL): ROLLERS (Arma la Imagen)
 */

export const GetThemes = async () => {
    return await DL.GetThemes();
};

export const GetTheme = async (id) => {
    return await DL.GetTheme(id);
};

export const SaveTheme = async (data) => {
    if (!data.name || data.name.trim() === '') {
        return { success: false, message: 'El nombre del tema es obligatorio.' };
    }
    return await DL.SaveTheme(data);
};

export const DeleteTheme = async (id) => {
    return await DL.DeleteTheme(id);
};

export const GetConfig = async (targetScreenId) => {
    return await DL.GetConfig(targetScreenId);
};

export const SaveConfig = async (data) => {
    return await DL.SaveConfig(data);
};

export const SpinMachine = async (formData) => {
    try {
        const targetScreenId = parseInt(formData.targetScreenId, 10) || 0;
        const playerName = formData.playerName || "Administrador";
        const playerContact = formData.playerContact || "";

        const payload = {
            targetScreenId,
            playerName,
            playerContact
        };

        const response = await DL.ExecuteSpin(payload);
        if (response.success) {
            return { success: true, data: response.data || response };
        } else {
            return { success: false, message: response.message || 'Error al ejecutar el giro.' };
        }
    } catch (error) {
        return { success: false, message: 'Excepción en BL al girar.' };
    }
};

export const PrepareMachine = async (screenId) => {
    return await DL.PrepareScreen(screenId);
};

export const GetActiveScreens = async () => {
    return await DL.GetScreens();
};

export const CreateMachineScreen = async (data) => {
    return await DL.AddScreen(data);
};

export const DeleteMachineScreen = async (id) => {
    return await DL.DeleteScreen(id);
};

export const IdentifyAllScreens = async () => {
    return await DL.IdentifyScreens();
};

export const UploadMedia = async (file, type) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', type);
    return await DL.UploadMedia(formData);
};

export const ShowCover = async (screenId) => {
    return await DL.ShowCover(screenId);
};

export const ToggleThanks = async (screenId, show) => {
    return await DL.ToggleThanks(screenId, show);
};

export const StopReel = async (screenId, reelIndex) => {
    return await DL.StopReel(screenId, reelIndex);
};
